// extracted by mini-css-extract-plugin
export var fadeIn = "_jr-1";
export var modalContent = "_jr-3";
export var overlay = "_jr-0";
export var popoverContent = "_jr-2";
export var results = "_jr-5";
export var searchInputWrapper = "_jr-4";